module.exports = __webpack_public_path__ + "img/discover.8ccd5ba4.png";